const SM = {

    selected: null,
    
    setSelected: function (pSelected) {
        if (this.selected != null) {
            this.selected.style.backgroundColor = '#f8f8f8';
            this.selected.style.fontWeight = 'normal';
        }
        this.selected = pSelected;
        this.selected.style.fontWeight = '600';
    },
    
    over: function (pObj) {
        pObj.style.backgroundColor = '#fae6ae';
    },
    
    out: function (pObj) {
        pObj.style.backgroundColor = '#f5f5f5';
    },
    
    selectOnLoad: function (pType) {
        const rds = document.getElementsByName('ship_method');
        for (let i = 0; i < rds.length; i++) {
            if (rds[i].value === pType && (typeof gon !== 'undefined' && gon.cart_items_size > 0)) {
                rds[i].checked = true;
                this.setSelected(rds[i].parentNode);
                return;
            }
        }
    },
    
    getSelectedVal: function () {
        const rds = document.getElementsByName('ship_method');
        for (let i = 0; i < rds.length; i++) {
            if (rds[i].checked) {
                return rds[i].value;
            }
        }
        return '';
    },
    
    setUI: function (pShipDest) {
        const cartItemsSize = (typeof gon !== 'undefined') ? gon.cart_items_size : 0;
        
        // Helper function to get element by ID
        const getElement = (id) => document.getElementById(id);
        
        // Helper function to show/hide and enable/disable elements
        const setElementState = (methodId, enabled, visible) => {
            const methodElement = getElement(`ship_method_${methodId}`);
            const rowElement = getElement(`row_${methodId}`);
            
            if (methodElement) {
                methodElement.disabled = !enabled;
            }
            if (rowElement) {
                rowElement.style.display = visible ? 'block' : 'none';
            }
        };

        if (cartItemsSize === 0) {
            // Hide all shipping methods when cart is empty
            ['FINT', 'USPS', 'FGR', 'F2D', 'FOV', 'CASTD', 'CAEXP'].forEach(methodId => {
                setElementState(methodId, false, false);
            });
        } else {
            // Set shipping methods based on destination
            if (pShipDest === "INT") {
                // International: Only FINT
                setElementState('FINT', true, true);
                ['USPS', 'FGR', 'F2D', 'FOV', 'CASTD', 'CAEXP'].forEach(methodId => {
                    setElementState(methodId, false, false);
                });
            } else if (pShipDest === "MIL") {
                // Military: Only USPS
                setElementState('USPS', true, true);
                ['FINT', 'FGR', 'F2D', 'FOV', 'CASTD', 'CAEXP'].forEach(methodId => {
                    setElementState(methodId, false, false);
                });
            } else if (pShipDest === "CAN") {
                // Canada: Only CASTD and CAEXP
                setElementState('CASTD', true, true);
                setElementState('CAEXP', true, true);
                ['FINT', 'USPS', 'FGR', 'F2D', 'FOV'].forEach(methodId => {
                    setElementState(methodId, false, false);
                });
            } else {
                // USA/NY: FGR, F2D, FOV
                ['FGR', 'F2D', 'FOV'].forEach(methodId => {
                    setElementState(methodId, true, true);
                });
                ['FINT', 'USPS', 'CASTD', 'CAEXP'].forEach(methodId => {
                    setElementState(methodId, false, false);
                });
            }
        }
    }

};

// Global function for Google Maps API callback
// This function is called by the Google Maps API when it loads
window.initShipAutocomplete = function() {
    console.log('Google Maps API loaded via initShipAutocomplete callback');
    
    // Check if there are any address controllers that need to initialize autocomplete
    const addressControllerElements = document.querySelectorAll('[data-controller*="address"]');
    
    addressControllerElements.forEach(element => {
        // Trigger the address controller to set up autocomplete now that the API is loaded
        const controller = element.stimulus?.address;
        if (controller && typeof controller.setupAddressAutocomplete === 'function') {
            controller.setupAddressAutocomplete();
        }
    });
    
    // Also check for any other elements that might need autocomplete
    const addressInputs = document.querySelectorAll('input[data-address-target="addressInput"]');
    addressInputs.forEach(input => {
        // If the input doesn't have autocomplete set up yet, trigger its controller
        if (!input.autocomplete) {
            const event = new CustomEvent('address:apiLoaded', { bubbles: true });
            input.dispatchEvent(event);
        }
    });
};